module.exports = __webpack_public_path__ + "img/farmer-groups.d2ffa716.svg";